import React from "react";
import DateComp from "../../../../core/common/dateComponent/DateComp";
import FormattedNumber from "../../../../core/common/textFields/FormatNumber";

const SummaryAcceptSaleWizard = ({
  jobScopeDetailsData,
  compareOpportunityDetailDataAccepted,
  formikAcceptedSale,
  saleInfoByApi,
  formikPermitSale,
  comment,
}: any) => {
  const filteredData = jobScopeDetailsData?.jobScopeResults?.filter(
    (item: { surveyResultOriginal: null }) => item.surveyResultOriginal !== null
  );

  const formatComma = (num: number | string) => {
    if (num === null || num === undefined) return "0.0";
    const numericValue = String(num).replace(/,/g, "");
    if (isNaN(Number(numericValue))) return String(num);
    return Number(numericValue).toLocaleString();
  };

  return (
    <>
      <div className="row border-gray">
        <div className="col-md-6">
          <h5 className="mt-2 mb-2">Summary Info</h5>
          <div className="d-flex">
            <p className="mb-2 w-50">Scheduling Notes:</p>
            <p className="mb-0">{formikAcceptedSale?.schedulingNotes}</p>
          </div>
          <div className="">
            <p className="mb-2 w-100">Job Description:</p>
            <p className="mb-0 h-25 overflow-auto">
              {saleInfoByApi?.result?.projectSaleInfo?.jobDescription}
            </p>
          </div>
          <div className="d-flex">
            <p className="mb-2 w-50">Sale Accepted Date:</p>
            <p className="mb-0">
              <DateComp formattedDate={formikAcceptedSale?.saleAcceptedDate} />
            </p>
          </div>
          <h5>Permit Info</h5>
          {formikPermitSale?.values?.projPermitResult?.map(
            (item: any, index: any) => (
              <div className="d-flex" key={index}>
                {item.name && (
                  <>
                    {" "}
                    <p className="mb-2 w-50">{item.name}:</p>
                    <p className="mb-0">
                      {item.surveyResultOriginal === "1" ? "Yes" : "No"}
                    </p>
                  </>
                )}
              </div>
            )
          )}
        </div>
        <div className="col-md-6">
          <h5 className="mt-2 mb-2">Cost Review</h5>
          <div className="d-flex">
            <p className="mb-2 w-50">PDM Job Cost:</p>
            <p className="mb-0">
              <FormattedNumber value={formikAcceptedSale?.pdmJobCost} />
            </p>
          </div>
          <div className="d-flex">
            <p className="mb-2 w-50">Cost Review Notes:</p>
            <p className="mb-0">{formikAcceptedSale?.costReviewNotes}</p>
          </div>
          <div className="d-flex">
            <p className="mb-2 w-50">Reviewed By:</p>
            <p className="mb-0">{formikAcceptedSale?.reviewedBy?.value}</p>
          </div>
          <div className="d-flex">
            <p className="mb-2 w-50">Reviewed Cost:</p>
            <p className="mb-0">
              <FormattedNumber value={formikAcceptedSale?.reviewedCost} />
            </p>
          </div>
          <div className="d-flex">
            <p className="mb-2 w-50">Amount:</p>
            <p className="mb-0">
              <FormattedNumber value={saleInfoByApi?.result?.projectSaleInfo?.salePrice} />
            </p>
          </div>
        </div>
      </div>
      <div className="row border-gray mt-2">
        <h5 className="mt-2 mb-2">Job Scope</h5>
        {filteredData.map((item: any, index: any) => (
          <li key={index}>
            <strong> {item.name} :</strong>
            {item?.fieldType === "OptionSingle"
              ? "Yes"
              : item.surveyResultOriginal}
          </li>
        ))}
      </div>
      <div className="row br-gray mt-2">
        <div className="d-flex align-items-center ">
          <h5 className=" w-25">Comments:</h5>
          <p className="mb-0">{comment}</p>
        </div>
      </div>
    </>
  );
};

export default SummaryAcceptSaleWizard;
